<template>
  <ngc-modal
    :open="showModal"
    variant="decide"
    :title.prop="title"
    data-testid="error-overflow-modal"
    @close="handleClose"
  >
    <pre>
      {{ message }}
    </pre>

    <!-- ngc-modal's decide footer hardcodes "Cancel"; filling the slot lets us label both buttons. -->
    <div
      slot="footer"
      class="error-overflow-actions"
    >
      <ngc-button
        variant="secondary"
        start-icon="copy"
        @click="handleCopy"
      >
        Copy Text
      </ngc-button>
      <ngc-button
        variant="primary"
        @click="handleClose"
      >
        Close
      </ngc-button>
    </div>
  </ngc-modal>
</template>

<script>

export default {
  name: 'ErrorOverflowModal',
  props: {
    toggleModal: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  watch: {
    toggleModal () {
      this.showModal = this.toggleModal
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    handleCopy () {
      navigator.clipboard.writeText(this.message)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>

pre {
  white-space: pre-line;
  word-wrap: break-word;
  word-break: break-word;
}

/* Mirrors Gator's .gator-modal-action-buttons so the slotted footer keeps stock spacing. */
.error-overflow-actions {
  display: flex;
  gap: var(--spacing-5);
  margin-left: auto;
}

@media (max-width: 600px) {
  .error-overflow-actions {
    flex-direction: column-reverse;
    width: 100%;
    margin-left: 0;
  }

  .error-overflow-actions ngc-button {
    --ngc-button-width: 100%;
  }
}

</style>
